import {useEffect, useState} from "react";
import {calculateVisualScore} from "../utils/analysisFunctions";

const EvalBar = (props) => {
    const mateRegex = /mate (.+)/
    //eval can be either a float like 0.75 or string "mate 2". If float we keep it as is, if mate string we convert it to a high
    //value in order to affect the bar significantly
    const [whiteLeading, setWhiteLeading] = useState(null)
    const [barValue, setBarValue] = useState(null)

    useEffect(() => {
        calculateBarValue(props.eval)
    }, [props.eval]);

    const calculateBarValue = (evalDiff) => {
        let value = calculateVisualScore(evalDiff);
        setWhiteLeading(value >= 0)

        setBarValue(Math.abs(value));
    }

    const calculateStyle = (isWhiteBar, isTop) => {
        //let style = isTop ? {justifySelf: "flex-end"} : {justifySelf: "flex-start"};
        let style = {}
        let isBarActive = isWhiteBar === whiteLeading;
        //If bar is not active we do not set background color (to keep invisible) but adjust
        if (!isBarActive) {
            style.height = "0%"
        } else {
            style.height = `${barValue}%`;
            style.backgroundColor = isWhiteBar ? "#fff" : "#000";
            style.border = "solid 1px gray";
            const borderRounding = isTop ? "borderTop" : "borderBottom";
            style[`${borderRounding}LeftRadius`] = "0.3rem";
            style[`${borderRounding}RightRadius`] = "0.3rem";
        }

        style.transition = "height 0.6s ease"
        style.flexDirection = isTop ? "column-reverse" : "column";
        return style;

    }

    const removeMinusFromMate = (evalString) => {
        if(typeof evalString === 'number') {
            return evalString
        }

        if(evalString.includes("-")) {
            const evalSplit = evalString.split("-")
            return evalSplit[0] + evalSplit[1]
        }
        return evalString
    }

    const isWhiteOrientation = props.orientation === "white"
    const topStyle = calculateStyle(!isWhiteOrientation, true)
    //looks stupid but we wanna depend on orientation at some point
    const botBarActive = isWhiteOrientation === whiteLeading
    const botStyle = calculateStyle(isWhiteOrientation, false)

    const evalStyle = {
        alignSelf: "center",
        fontSize: "0.6rem",
        color: "gray",
        marginTop: "0rem",
        marginBottom: "0rem"
    }

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100%", width: "1.5rem"}}>
            <div style={{height: "50%", display: "flex", flexDirection: `${topStyle.flexDirection}`}}>
                <div style={{
                    ...topStyle,
                    display: "flex",
                    alignItems: "center",
                }}>
                    <p style={{
                        ...evalStyle
                    }}>{botBarActive && removeMinusFromMate(props.eval)}</p></div>
            </div>
            <div style={{height: "50%", display: "flex", flexDirection: `${botStyle.flexDirection}`}}>
                <div style={{
                    ...botStyle,
                    display: "flex",
                    alignItems: "center",
                }}>
                    <p style={{
                        ...evalStyle
                    }}>{!botBarActive && removeMinusFromMate(props.eval)}</p></div>
            </div>
        </div>)
}

export default EvalBar;